const MODULE_NAME = 'TasksModule';

export const SET_CURRENT_TASK = `${MODULE_NAME}/SET_CURRENT_TASK`;
export const UNLOAD_CURRENT_TASK = `${MODULE_NAME}/UNLOAD_CURRENT_TASK`;
export const SET_CURRENT_TASK_DIAGRAM_SOURCE = `${MODULE_NAME}/SET_CURRENT_TASK_DIAGRAM_SOURCE`;
export const LOCAL_SET_CURRENT_TASK = 'SET_CURRENT_TASK';
export const SET_CURRENT_FOLDER = `${MODULE_NAME}/SET_CURRENT_FOLDER`;
export const LOCAL_SET_CURRENT_FOLDER = 'SET_CURRENT_FOLDER';
